import { format, isBefore } from "date-fns"

const getAvailability = (options) => {
  if (!options.find((option) => option.space_available === false)) {
    return "Immediately"
  }
  if (
    options.length > 0 &&
    options[0].space_available_from &&
    isBefore(new Date(), new Date(options[0].space_available_from))
  ) {
    return format(new Date(options[0].space_available_from), "yyyy-MM-dd")
  }
  return "Immediately"
}
export default getAvailability
